const ariesConfigs = require(`./aries-configs.${
  process.env.REACT_APP_SERVICE_ENV || "local"
}`).default;

export default ariesConfigs;
